// ** Auth Endpoints
export default {
  loginEndpoint: `${process.env.REACT_APP_IDENTITY_BASEURL}/auth/login`,
  registerEndpoint: `${process.env.REACT_APP_IDENTITY_BASEURL}/auth/register`,
  refreshEndpoint: `${process.env.REACT_APP_IDENTITY_BASEURL}/token/refresh`,
  logoutEndpoint: `${process.env.REACT_APP_IDENTITY_BASEURL}/auth/logout`,

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
